import { z } from 'zod';

import { Current } from './Current';

export const MaximumPowerPointCurrent = {
    validator: Current.validators.value,
    units: Current.units,
};

export type MaximumPowerPointCurrent = z.infer<typeof MaximumPowerPointCurrent.validator>;
